export { default } from "./DealRow";
